// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__s-kHd","modalFooterButton":"ModalNotes_modalFooterButton__jvYTf"};